module.exports = __webpack_public_path__ + "img/ajio.e5ddfc4d.png";